<template>
  <div style="display: flex; justify-content: flex-end;">
    <el-button type="primary" :disabled="disabled" @click="syncContainerInfoDialogHandle">{{ $t('SeaExport.SyncContainerInfoTotal') }}</el-button>
    <!--取装箱信息件毛体-->
    <sync-container-info-dialog
      ref="syncContainerInfoDialog"
      :visible.sync="syncContainerInfoDialog.visible"
      @okCallback="syncContainerInfoChangeHandle"
    />
  </div>
</template>

<script>
import SyncContainerInfoDialog from '@/components/Cargo/Job/syncContainerInfoDialog.vue'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'

export default {
  name: 'SeMblSyncContainerInfoTotal',
  components: { SyncContainerInfoDialog },
  props: {
    job: { type: Object, default: () => { return {} } },
    cargoDoc: { type: Object, default: () => { return {} } },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      syncContainerInfoDialog: {
        visible: false
      }
    }
  },
  methods: {
    syncContainerInfoDialogHandle() {
      const params = {}
      params.quantityArray = [this.cargoDoc.quantity, 0]
      params.weightArray = [this.cargoDoc.weight, 0]
      params.cubageArray = [this.cargoDoc.cubage, 0]
      params.cargoDoc = this.cargoDoc
      // 拆并单取不同过的信息进行处理
      if (this.job.typeMBL === BillType.NORMAL_BILL_TYPE.code) {
        if (this.job.containerUsages) {
          CargoDocUtil.fillTotalQuantityAndWeightAndCubageByContainerInfo(params, this.job.containerUsages)
          this.syncContainerInfoDialog.visible = true
          this.$refs.syncContainerInfoDialog.initInfo(params)
        }
      } else if (this.job.typeMBL === BillType.MERGE_BILL_TYPE.code || this.job.typeMBL === BillType.SPLIT_BILL_TYPE.code) {
        if (this.cargoDoc.ediContainer) {
          // 存在删除的情况，删除时deleted为true
          const filteredEdiContainer = this.cargoDoc.ediContainer.filter(item => !item.deleted)
          CargoDocUtil.fillTotalQuantityAndWeightAndCubageByContainerInfo(params, filteredEdiContainer)
          this.syncContainerInfoDialog.visible = true
          this.$refs.syncContainerInfoDialog.initInfo(params)
        }
      }
    },
    syncContainerInfoChangeHandle() {
      const items = []
      items.push({ key: 'quantity', value: this.cargoDoc.quantity })
      items.push({ key: 'weight', value: this.cargoDoc.weight })
      items.push({ key: 'cubage', value: this.cargoDoc.cubage })
      items.push({ key: 'chargeWeight', value: this.cargoDoc.chargeWeight })
      this.$emit('childrenChange', items)
    }
  }
}
</script>
